import React, { useMemo } from 'react';
import { NavBar } from 'antd-mobile';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { t } from '../../i18n';
import { getNavBarContainerStyle } from '../../utils/deviceUtils';

interface DocumentViewerProps {
    titleKey: string;
    documentType: 'terms' | 'privacy';
}

const DocumentViewer: React.FC<DocumentViewerProps> = ({ titleKey, documentType }) => {
    const navigate = useNavigate();
    const { i18n } = useTranslation();
    const navBarStyle = getNavBarContainerStyle();

    // 根据语言和文档类型计算 HTML 文件路径
    const htmlUrl = useMemo(() => {
        const language = i18n.language;
        let lang = 'en';

        if (language === 'zh' || language === 'zh-CN') {
            lang = 'zh';
        } else if (language === 'es' || language === 'es-ES') {
            lang = 'es';
        }

        const fileName = documentType === 'terms'
            ? `terms-of-use-${lang}.html`
            : `privacy-policy-${lang}.html`;

        return `/documents/${fileName}`;
    }, [i18n.language, documentType]);

    return (
        <div className="h-screen bg-white flex flex-col overflow-hidden">
            <NavBar
                onBack={() => navigate(-1)}
                style={navBarStyle.style}
            >
                {t(titleKey)}
            </NavBar>

            <div className="flex-1 overflow-hidden" style={{ height: 0 }}>
                <iframe
                    src={htmlUrl}
                    className="w-full h-full border-0"
                    style={{
                        display: 'block',
                        width: '100%',
                        height: '100%',
                    }}
                    title={t(titleKey)}
                    sandbox="allow-same-origin allow-popups allow-top-navigation allow-scripts"
                />
            </div>
        </div>
    );
};

export default DocumentViewer;

